import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "color": "danger",
      "title": _vm.$i18n_t('Bridges.Consumers.chains.deletePrompt.title'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'danger',
        emit: 'delete'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": function ($event) {
        return _vm.deleteConsumer(_vm.deleteItemId);
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Bridges.Consumers.chains.deletePrompt.description', {
    title: (_vm.consumers.find(t => t.id === _vm.deleteItemId) || {}).name
  })) + "\n  ")]), _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.formDialogOpen,
      "max-width": "85%",
      "persistent": ""
    },
    on: {
      "close": _vm.closeDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c(VRow, {
          staticStyle: {
            "flex-wrap": "nowrap",
            "width": "100%"
          },
          attrs: {
            "no-gutters": ""
          }
        }, [_c(VCol, {
          staticClass: "flex-grow-1 flex-shrink-0"
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t(`Bridges.Consumers.chains.${_vm.consumerModel.id ? 'update' : 'create'}`)) + "\n        ")]), _c(VCol, {
          staticClass: "flex-grow-0 flex-shrink-1",
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c(VSwitch, {
          staticClass: "mt-0",
          attrs: {
            "hide-details": "",
            "color": _vm.color,
            "label": _vm.consumerModel.active ? _vm.$i18n_t('Bridges.Consumers.chains.enabledToggle') : _vm.$i18n_t('Bridges.Consumers.chains.disabledToggle'),
            "disabled": _vm.isTogglingActive || !_vm.canManageIntegrations,
            "data-cy": "integrationflowActive"
          },
          on: {
            "change": value => _vm.toggleActive(value)
          },
          model: {
            value: _vm.consumerModel.active,
            callback: function ($$v) {
              _vm.$set(_vm.consumerModel, "active", $$v);
            },
            expression: "consumerModel.active"
          }
        })], 1)], 1)];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_vm.canManageIntegrations ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.dialogFormValid,
            "prepend-icon": "fa-plus",
            "data-cy": "saveIntegrationflowButton"
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("\n        " + _vm._s(_vm.consumerModel.id ? _vm.$i18n_t('Common.save') : _vm.$i18n_t('Common.create')) + "\n      ")]) : _vm._e()];
      },
      proxy: true
    }])
  }, [_vm.formDialogOpen ? _c('core-consumers-chains-edit', {
    ref: "chainsEdit",
    attrs: {
      "accounts": _vm.accounts,
      "selectedAccount": _vm.selectedAccount,
      "consumerModel": _vm.consumerModel,
      "triggerSources": _vm.triggerSources,
      "bridgeTypes": _vm.bridgeTypes,
      "isCreateDialog": _vm.isCreateDialog,
      "readonly": !_vm.canManageIntegrations
    },
    on: {
      "change-valid-form": val => _vm.dialogFormValid = val
    }
  }) : _vm._e()], 1), _c('core-header', {
    attrs: {
      "subtitle": _vm.$i18n_t('Bridges.Consumers.chains.description')
    },
    scopedSlots: _vm._u([{
      key: "headline",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Bridges.Consumers.chains.headline')) + "\n    ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            }
          }
        }), _vm.canManageIntegrations ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": _vm.isLoading,
            "tooltip": _vm.isLoading ? _vm.$i18n_t('Bridges.Consumers.chains.createTooltipNoConnector') : '',
            "prepend-icon": "fa-plus",
            "data-cy": "createIntegrationflowButton"
          },
          on: {
            "click": function ($event) {
              return _vm.openEditModal();
            }
          }
        }, [!_vm.isMobile ? [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.create')) + "\n        ")] : _vm._e()], 2) : _vm._e()];
      },
      proxy: true
    }])
  }), !_vm.isLoading ? _c('div', {
    staticClass: "n20-mainrow pt-4"
  }, [_c('core-n20Card', [!_vm.isLoading && _vm.hasNoChains ? _c('core-empty-state', {
    attrs: {
      "icon": "fa-angle-double-right",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.Consumers.chains.noChainsTitle')) + "\n        ")];
      },
      proxy: true
    }, {
      key: "button",
      fn: function () {
        return [_vm.canManageIntegrations ? _c('core-button', {
          staticClass: "mt-4",
          attrs: {
            "color": _vm.color,
            "append-icon": "fa-arrow-right"
          },
          on: {
            "click": function ($event) {
              return _vm.openEditModal();
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Bridges.Consumers.chains.noChainsButton')) + "\n          ")]) : _vm._e()];
      },
      proxy: true
    }], null, false, 975060077)
  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.Consumers.chains.noChainsTextP1')) + "\n        ")])]) : [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": "",
      "data-cy": "searchIntegrationflow"
    },
    on: {
      "click:clear": function ($event) {
        _vm.searchItem = '';
      }
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  }), _c(VDataTable, {
    attrs: {
      "data-cy": "integration_flow_table",
      "data-cy-state": _vm.isLoading ? 'loading' : 'loaded',
      "search": _vm.searchItem,
      "items": _vm.consumers,
      "loading": _vm.isLoading,
      "options": _vm.tableOptions,
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.footerProps,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.active",
      fn: function ({
        item
      }) {
        return [_c('span', {
          attrs: {
            "data-cy": "integrationflow_active_state",
            "data-cy-active": String(Boolean(item.active))
          }
        }, [item.active ? _c(VIcon, {
          attrs: {
            "color": "success",
            "small": ""
          }
        }, [_vm._v("fal fa-check-circle")]) : _c(VIcon, {
          attrs: {
            "color": "primary",
            "small": ""
          }
        }, [_vm._v("fal fa-lightbulb-slash")]), _vm._v("\n              " + _vm._s(item.active ? _vm.$i18n_t('Common.active') : _vm.$i18n_t('Bridges.Consumers.chains.inactive')) + "\n            ")], 1)];
      }
    }, {
      key: "item.triggerType",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s((_vm.triggerSources.find(t => t.value === item.trigger.source) || {}).text) + "\n            "), _c('br'), _c('code', {
          staticStyle: {
            "font-size": "xx-small"
          }
        }, [_vm._v(_vm._s(item.trigger.source))])];
      }
    }, {
      key: "item.bridges",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "210px"
          }
        }, [_vm._l(item.bridges, function (bridge) {
          return [_vm._v("\n                " + _vm._s(bridge.name) + " (" + _vm._s(bridge.displayName) + ")\n                "), _c('br')];
        })], 2)];
      }
    }, {
      key: "item.tenantId",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s((_vm.accounts.find(t => t.id === item.tenantId) || {}).name) + "\n          ")];
      }
    }, {
      key: "item.createdAt",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(_vm.localizeDate(item.createdAt)) + "\n          ")];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.viewDetails'),
            "small": "",
            "data-cy": "edit_btn"
          },
          on: {
            "click": function ($event) {
              return _vm.openEditModal(item);
            }
          }
        }, [_vm._v("\n              fal " + _vm._s(_vm.canManageIntegrations ? 'fa-edit' : 'fa-eye') + "\n            ")]), _vm._v("\n             \n            "), _vm.canManageIntegrations ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDelete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.showDeletePrompt(item.id);
            }
          }
        }, [_vm._v("\n              fal fa-trash-alt\n            ")]) : _vm._e()];
      }
    }], null, false, 3367810977)
  })]], 2), _c('br'), _c('br')], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };